// Application ENV config

export const appBaseName = process.env.REACT_APP_ROUTE_BASE_PATH_NAME || "/";

// menuType is component name
//pData is whole permissionAPIData
export const individualPermissionData = (pData, menuType) => {
  const filterData = pData.filter((data) => {
    return data.componentName === menuType;
  });
  return filterData;
};
